import React from 'react'
import './loader1.css'

const Loader = (props) => {
  return (
    <div className="loader">Loading...</div>
  )
}

export default Loader
